import { apiClient } from "../../lib/api";
import type { MailBatch } from "../../types/directMail";
const base = "/api/marketing/direct-mail";
export interface MailPlan {
  selected_count: number;
  piece_count: number;
  included: { id: number; address: string }[];
  excluded: { id: number; address: string; reason: string }[];
  included_pages: string[];
  unit_price: string;
  total_amount: string;
  note: string;
}
export interface MailPiece {
  id: number;
  address: string;
  proof_url: string | null;
  pages: number | null;
  scan_url: string | null;
  quote_low: string;
  quote_high: string;
  status: string;
  provider_piece_id: string;
  error: string;
  attempted_at: string | null;
  mailed_at: string | null;
  delivered_at: string | null;
  events: { type: string; at: string }[];
}
export interface MailWorkspace {
  batch: MailBatch & { proof_pdf_url?: string };
  pieces: MailPiece[];
  included_pages: string[];
  approval_name: string | null;
}
export const mailWorkflows = {
  plan: async (campaign: number, pin_ids: number[]) =>
    (
      await apiClient.post<MailPlan>(`${base}/batches/plan/`, {
        campaign,
        pin_ids,
      })
    ).data,
  workspace: async (id: number) =>
    (await apiClient.get<MailWorkspace>(`${base}/batches/${id}/workspace/`))
      .data,
  approve: async (id: number, proof_version: string) =>
    (
      await apiClient.post(`${base}/batches/${id}/approve-proof/`, {
        proof_version,
        confirmed: true,
      })
    ).data,
  retry: async (id: number) =>
    (await apiClient.post(`${base}/batches/${id}/retry-pieces/`, {})).data,
  reconcile: async (
    id: number,
    data: {
      pin_id: number;
      outcome: string;
      note: string;
      provider_piece_id: string;
      provider_verified: boolean;
    },
  ) =>
    (await apiClient.post(`${base}/batches/${id}/reconcile-piece/`, data)).data,
};

export const mailPageLabel = (page: string) =>
  ({
    cover: "Cover",
    detailed_estimate: "Detailed estimate",
    about_us: "About us",
    promotions: "Promotions",
    why_now: "Why now",
    next_steps: "Next steps",
  })[page] ?? page.replaceAll("_", " ");
